// Legacy reports (hidden): imports used only by the routes commented out below.
/*
import {
  dashboardGetActiveMembershipsGraph,
  dashboardGetActiveMembershipsRanking,
  dashboardGetAttendanceGraph,
  dashboardGetClassAttendanceRanking,
  dashboardGetFirstTimersGraph,
  dashboardGetFirstTimersRanking,
  dashboardGetMembershipRevenueGraph,
  dashboardGetMembershipsRevenueRanking,
  dashboardGetgymsPerformance,
} from 'modules/dashboards/actions';
*/
import {
  listCoupons,
  listDiscounts,
  listMemberMethods,
  listMemberTypes,
  listMemberTypesMethods,
  listPackages,
  listPricelists,
  listSkus,
  listSkusCategories,
} from 'modules/sku-manager/actions';

// import { listUsers } from 'modules/users/actions';
// import { listKeyMetricsUrls } from 'modules/looker/actions';
import GeneralSettings from 'views/screens/settings/general';
import Loadable from 'react-loadable';
import NotFound from 'views/components/not-found';
import ScreenLoading from 'views/ui/screen-loading';
import { listEmails } from 'modules/emails/actions';
// User Manager moved to the accounts app (hidden):
// import { USER_MANAGER_PERMISSIONS } from 'utils/casl/route-permissions';
// import { getPaginatedListIncomeReport } from 'modules/income-report/actions';
import { listHolidayHours } from 'modules/holiday-hours/actions';
import { listMeGyms } from 'modules/gyms/actions';
// import { listRoles } from 'modules/roles/actions';
import { listStandardHours } from 'modules/std-hours/actions';
// import KeyMetricsReports from 'views/screens/reports/key-metrics-reports';
import { snowflakeGetLocations } from 'modules/snowflake/actions';
// Legacy reports (hidden):
/*
import {
  listReportLog,
  listReports,
  listScheduled,
} from 'modules/reports/actions';
*/

const SnowflakeDashboard = Loadable({
  loader: () => import('views/screens/snowflake'),
  loading: ScreenLoading,
});

const NetworkPerformanceDashboard = Loadable({
  loader: () => import('views/screens/network-performance'),
  loading: ScreenLoading,
});

const FinancialReport = Loadable({
  loader: () => import('views/screens/financial-report'),
  loading: ScreenLoading,
});

const MetricsReference = Loadable({
  loader: () => import('views/screens/metrics-reference'),
  loading: ScreenLoading,
});

const Root = Loadable({
  loader: () => import('views/screens/login'),
  loading: ScreenLoading,
});

const ResetPassword = Loadable({
  loader: () => import('views/screens/reset-password'),
  loading: ScreenLoading,
});

const Welcome = Loadable({
  loader: () => import('views/screens/welcome'),
  loading: ScreenLoading,
});

const ContainerDashboard = Loadable({
  loader: () => import('views/containers/dashboard'),
  loading: ScreenLoading,
});

const StandardSchedule = Loadable({
  loader: () => import('views/screens/schedule-manager/standard-schedule'),
  loading: ScreenLoading,
});

const HolidaySchedule = Loadable({
  loader: () => import('views/screens/schedule-manager/holiday-schedule'),
  loading: ScreenLoading,
});

// User Manager moved to https://accounts.sweat440.dev/users (hidden):
// const UserManager = Loadable({
//   loader: () => import('views/screens/user-manager'),
//   loading: ScreenLoading,
// });

const Discounts = Loadable({
  loader: () => import('views/screens/sku-manager/discounts'),
  loading: ScreenLoading,
});

const Coupons = Loadable({
  loader: () => import('views/screens/sku-manager/coupons'),
  loading: ScreenLoading,
});

const SKU = Loadable({
  loader: () => import('views/screens/sku-manager/skus'),
  loading: ScreenLoading,
});

const Packages = Loadable({
  loader: () => import('views/screens/sku-manager/packages'),
  loading: ScreenLoading,
});

const Pricelists = Loadable({
  loader: () => import('views/screens/sku-manager/pricelists'),
  loading: ScreenLoading,
});

const TypesMethods = Loadable({
  loader: () => import('views/screens/sku-manager/member-manager'),
  loading: ScreenLoading,
});

// Legacy reports (hidden): screens behind the routes commented out below.
/*
const MyReports = Loadable({
  loader: () => import('views/screens/reports/my-reports'),
  loading: ScreenLoading,
});

const ReportGeneration = Loadable({
  loader: () => import('views/screens/reports/report-generate'),
  loading: ScreenLoading,
});

const ReportScheduler = Loadable({
  loader: () => import('views/screens/reports/report-schedule'),
  loading: ScreenLoading,
});

const EditReportScheduler = Loadable({
  loader: () => import('views/screens/reports/edit-report-schedule'),
  loading: ScreenLoading,
});

*/

const SettingsByLocation = Loadable({
  loader: () => import('views/screens/settings/location'),
  loading: ScreenLoading,
});

// Legacy reports (hidden):
/*
const Dashboard = Loadable({
  loader: () => import('views/screens/dashboard'),
  loading: ScreenLoading,
});
*/

// Income report is not used anymore
/*
const IncomeReport = Loadable({
  loader: () => import('views/screens/income-report'),
  loading: ScreenLoading,
});
*/

const routes = [
  {
    path: '/',
    component: Root,
    exact: true,
    published: true,
  },
  {
    path: '/login',
    component: Root,
    exact: true,
    published: true,
  },
  {
    path: '/reset-password/:token',
    component: ResetPassword,
    exact: true,
    published: true,
  },
  {
    path: '/app',
    component: ContainerDashboard,
    privated: true,
    actions: [listMeGyms],
    routes: [
      {
        path: '/app',
        component: Welcome,
        exact: true,
      },
      /*
      Legacy reports (hidden) — Reports Dashboard
      {
        path: '/app/dashboard',
        component: Dashboard,
        exact: true,
        actions: [
          () => listMeGyms({ isLegacy: true }),
          dashboardGetFirstTimersGraph,
          dashboardGetAttendanceGraph,
          dashboardGetMembershipRevenueGraph,
          dashboardGetActiveMembershipsGraph,
          dashboardGetgymsPerformance,
          dashboardGetFirstTimersRanking,
          dashboardGetClassAttendanceRanking,
          dashboardGetMembershipsRevenueRanking,
          dashboardGetActiveMembershipsRanking,
        ],
      },
      */
      {
        path: '/app/gym-hours/standard',
        component: StandardSchedule,
        exact: true,
        actions: [listStandardHours],
      },
      {
        path: '/app/gym-hours/holiday',
        component: HolidaySchedule,
        exact: true,
        actions: [listHolidayHours],
      },
      /*
      User Manager moved to https://accounts.sweat440.dev/users (hidden).
      {
        path: '/app/user-manager',
        component: UserManager,
        exact: true,
        // Same set the sidebar link is gated on. Without it the user is signed out and
        // told why, rather than landing on a screen whose every call 401s.
        requiredPermissions: USER_MANAGER_PERMISSIONS,
        actions: [listUsers, listRoles, listMeGyms],
      },
      */
      {
        path: '/app/sku-manager/discounts',
        component: Discounts,
        exact: true,
        actions: [listDiscounts],
      },
      {
        path: '/app/sku-manager/coupons',
        component: Coupons,
        exact: true,
        actions: [
          listCoupons,
          listDiscounts,
          listMemberMethods,
          listMemberTypes,
        ],
      },
      {
        path: '/app/sku-manager/skus',
        component: SKU,
        exact: true,
        actions: [listSkus, listSkusCategories, listPackages],
      },
      {
        path: '/app/sku-manager/packages',
        component: Packages,
        exact: true,
        actions: [listPackages, listSkus, listSkusCategories, listDiscounts],
      },
      {
        path: '/app/sku-manager/pricelist',
        component: Pricelists,
        exact: true,
        actions: [listPricelists],
      },
      {
        path: '/app/sku-manager/members-t&m/',
        component: TypesMethods,
        exact: true,
        actions: [listMemberTypesMethods],
      },
      /*
      Legacy reports (hidden) — New Report, Reports History, schedules
      {
        path: '/app/reports/list/',
        component: MyReports,
        exact: true,
        actions: [listReportLog, listReports],
      },
      {
        path: '/app/reports/generate/',
        component: ReportGeneration,
        exact: true,
        actions: [listReports, () => listMeGyms({ isLegacy: true })],
      },
      {
        path: '/app/reports/schedule/',
        component: ReportScheduler,
        exact: true,
        actions: [listScheduled, listReports],
      },
      {
        path: '/app/reports/schedule/edit',
        component: EditReportScheduler,
        exact: true,
      },
      */
      /*
      Income report is not used anymore
      {
        path: '/app/reports/income-report',
        component: IncomeReport,
        exact: true,
        actions: [listMeGyms, getPaginatedListIncomeReport],
      },
      */
      /*
      Looker report is not used anymore
      {
        path: '/app/reports/looker',
        component: LookerReports,
        exact: true,
        actions: [listLookerUrls],
      },
      */
      /*
      Key metrics report not used anymore
      {
        path: '/app/reports/key-metrics',
        component: KeyMetricsReports,
        exact: true,
        actions: [listKeyMetricsUrls],
      },
      */
      {
        path: '/app/settings/location/',
        component: SettingsByLocation,
        exact: true,
        actions: [listMeGyms],
      },
      {
        path: '/app/settings/general',
        component: GeneralSettings,
        exact: true,
        actions: [listEmails],
      },
      {
        path: '/app/mindbody',
        component: SnowflakeDashboard,
        exact: true,
        actions: [snowflakeGetLocations],
      },
      {
        path: '/app/network-performance',
        component: NetworkPerformanceDashboard,
        exact: true,
        actions: [() => snowflakeGetLocations({ ignorePre: true })],
      },
      {
        path: '/app/financial-report',
        component: FinancialReport,
        exact: true,
        // Financial figures are admin-only. Denial also suppresses the actions below,
        // so no non-admin request is made on the way to the redirect.
        requiredRole: 'Admin',
        // ignorePre matches the report endpoint, which drops Pre-Sales studios
        // and tags the rest with an openingCategory the studio filter reads.
        actions: [() => snowflakeGetLocations({ ignorePre: true })],
      },
      {
        path: '/app/metrics',
        component: MetricsReference,
        exact: true,
      },
      // Unknown path inside the app: the frame is already mounted and no child matches,
      // so without this the user just gets an empty content area.
      {
        path: '*',
        component: NotFound,
        to: '/app',
      },
    ],
  },
  {
    name: '404',
    path: '*',
    component: NotFound,
    to: '/',
  },
];

export default routes;
